module.exports = __webpack_public_path__ + "img/cloudy-day-1.80a5d865.svg";